import { useEffect } from 'react'
import { useLanguage } from '../../context/LanguageContext'

const SITE_NAME = 'Mayar International Schools'
const SITE_URL = 'https://mayarschools.edu.jo'

function upsertMeta(name, content) {
  if (!content) return
  let tag = document.querySelector(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

export default function PageMeta({ title, description, path = '' }) {
  const { language } = useLanguage()
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME
  const url = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`

  useEffect(() => {
    document.title = fullTitle
    upsertMeta('description', description || '')
    upsertMeta('og:title', fullTitle)
    upsertMeta('og:description', description || '')
    upsertMeta('og:url', url)
    upsertMeta('og:locale', language === 'ar' ? 'ar_JO' : 'en_US')
    document.documentElement.lang = language === 'ar' ? 'ar' : 'en'
  }, [fullTitle, description, url, language])

  return null
}
